import { NamedComplexEnum } from '../../utils/complexEnum/NamedComplexEnum'
import {
  CreatedDateAsc,
  CreatedDateDesc,
  FilenameAsc,
  FilenameDesc,
  LastEditedDateAsc,
  LastEditedDateDesc,
} from './instances'

export type CASPacketAttachmentOrderItem =
  | typeof CreatedDateAsc
  | typeof CreatedDateDesc
  | typeof LastEditedDateAsc
  | typeof LastEditedDateDesc
  | typeof FilenameAsc
  | typeof FilenameDesc

class CASPacketAttachmentOrderEnum extends NamedComplexEnum<
  'PacketAttachmentOrder',
  CASPacketAttachmentOrderItem,
  CASPacketAttachmentOrderItem['name'],
  CASPacketAttachmentOrderItem['id']
> {
  readonly typename = 'PacketAttachmentOrder'
  readonly CreatedDateAsc = CreatedDateAsc
  readonly CreatedDateDesc = CreatedDateDesc
  readonly LastEditedDateAsc = LastEditedDateAsc
  readonly LastEditedDateDesc = LastEditedDateDesc
  readonly FilenameAsc = FilenameAsc
  readonly FilenameDesc = FilenameDesc

  get values() {
    return [
      this.CreatedDateAsc,
      this.CreatedDateDesc,
      this.LastEditedDateAsc,
      this.LastEditedDateDesc,
      this.FilenameAsc,
      this.FilenameDesc,
    ]
  }
}

export const CASPacketAttachmentOrder = new CASPacketAttachmentOrderEnum()
